<div usbLoadingSplash
     [appLoading]="appLoading"
     [fullscreen]="true"
>

<div id="bg-summary m-0">
    <usb-navbar-search-categories [getClientsSettingAppBooking]="getClientsSettingAppBooking"
                              [_results]=""
></usb-navbar-search-categories>

  <div class="top-summary" style="background-color: white! important; padding-bottom: 30px;">


    <div class="resumen pt-2 px-2">
      <usb-data-itinerary
                          *ngIf="itinerary && screen"
                          [screen]="screen"
                          [idConfirmation]="idConfirmation"
                          [itinerary]="itinerary"
                          [idReservation]="idReservation"
                          [payloadSearch]="payloadSearchTransportFly"
                          [formTransports]="formTransportsFly"
      >
      </usb-data-itinerary>
    </div>
    <div class="d-flex resumen-itinerary p-4 mt-2">
      <!-- <div class="pr-5 pl-5">
        <div class="row bg-white mx-auto content-detail-cards justify-content-between"> -->


        <div *ngIf="itinerary && destinationsArray" style="width: calc(100% - 347px);padding-right: 20px">
            <div *ngFor="let destination of destinationsArray; let i=index" >

                <div class="row pb-2 pr-2" [ngStyle]="{'margin-top': i === 0 ? '' : '25px'}">
                    <div class="d-flex justify-content-between pr-2" style="width: 100%; height: 54px;">
                        <div class="destination-iata content-detail-green d-flex align-items-center justify-content-center"
                         [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_3}">
                            <p class=" font-poppins text-center f-15 font-weight-bold m-0" [ngStyle]="{'color': headerStyle?.color}" >{{formatIata(destination.iata)}}</p>
                        </div>
                        <!-- [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_2}" -->
                        <div class="destination content-detail-dark d-flex align-items-center justify-content-start px-3"
                             [ngStyle]="{'background-color': headerStyle?.background_color_header}"
                          >
                            <p class=" font-weight-medium font-poppins f-15 m-0" [ngStyle]="{'color': headerStyle?.color}">{{destination.city}} &nbsp;
                                <span *ngIf="destination?.arrival && destination?.departure" class="f-15 font-weight-medium border-less" [ngStyle]="{'color': headerStyle?.color_3}">
                                    IN: <span style="text-transform: capitalize;">{{getDateInOut(destination.arrival)}}</span> &nbsp; | &nbsp; OUT: <span style="text-transform: capitalize;">{{getDateInOut(destination.departure)}}</span>
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
                <!-- list cards itinerary -->
                <div class="row pr-3" *ngIf="destination.items">
                    <div *ngIf="destination.items" style="width: 100%;">

                       <!-- <ng-container *ngFor="let item of destination.items; let i=index">-->
                        <ng-container *ngFor="let item of destination.items; let i=index">
                            <usb-card-itinerary *ngIf="item.status_id != 4" #card
                                (reserve)="reserveItem($event)"
                                [itinerary]="itinerary"
                                (delete)="deleteItem($event)"
                                (cancel)="cancelReservations($event)"
                                [changePriceFromReserve]="changePriceFromReserve"
                                [item]="item"
                                [_status]="status"
                                [showTextChangeDetailsProducts]="showTextChangeDetailsProducts"
                                [getClientsSettingAppBooking]="getClientsSettingAppBooking"
                                [index]="i"
                                [reservation]="findReservedProduct(item)"
                                [currencies]="currencies"
                                [currencyAgency]="currencyAgency"
                                [partialReserve]="isActivePartialReserve"
                                (itemToPartial)="_itemToPartial($event)"
                                (modifications) ="_modifications()"
                                (reloadItinerary)="_reloadItinerary()"
                                (partialSelection)="onPartialSelection($event)"
                                (loadingSplash)="loadingCancelSplash($event)"
                                >
                            </usb-card-itinerary>

                            <!--   [_status]="item?.syncProduct?.codeStatus" -->
                       </ng-container>
                    </div>
                </div>
            </div>
        </div>
        <!-- usb-price-itinerary   *ngIf="isUpdate"  -->
        <div  style="width: 347px; left: 200px;">
            <usb-price-itinerary *ngIf="!appLoading"
                (updateEmitter)="updateCards(false, 'sync')"
                [netPriceBookingFreeTax]="netPriceBookingFreeTax"
                [getClientsSettingAppBooking]="getClientsSettingAppBooking"
                [netPriceBooking]="netPriceBooking"
                [taxSum]="taxSum"
                [modifications]="modifications"
                [currencies]="currencies"
                [currencyAgency]="currencyAgency"
                [itinerary]="itinerary"
                [screen]="screen"
                [partialReserve]="isActivePartialReserve"
                [buttonTextActive]="buttonTextActive"
                [showPartialContainer]="showPartialContainer"
                (globalFeeUnavaibleWithAmount)="globalFeeUnavaibleWithAmount()"
            >

            </usb-price-itinerary>
            <ng-container *ngIf="itinerary && screen === 'addFee'">
                <div class="row pl-2 mt-2">
                    <button *ngIf="itinerary.status_id!==3 && goTo=='saveDraft' " class="btn btn-danger btn-block btn-big text-uppercase" (click)="save()">
                        Continue
                    </button>
                </div>

                <div class="row pl-2 mt-2">
                    <button *ngIf="itinerary.status_id != 3 && itinerary.status_id != 4 && itinerary.status_id != 5 && itinerary.status_id != 6"
                    class="btn btn-danger btn-block btn-big text-uppercase" (click)="reserve()"
                    [disabled]="((isActivePartialReserve && qtyItemsToPartial==0 || modifications))">
                        Reserve
                    </button>
                </div>

                <div class="row pl-2 mt-2">
                    <button *ngIf="itinerary.items.length > 1 && itinerary.status_id != 3 && itinerary.status_id != 4 && itinerary.status_id != 5 && itinerary.status_id != 6 && activeButtonPartialReserve" class="btn btn-danger btn-block btn-big text-uppercase" (click)="activePartial()">
                        Reserve
                    </button>
                </div>
            </ng-container>

            <ng-container *ngIf="itinerary && screen === 'detail'">
              <div class="row pl-2 justify-content-between">
                <div class="mt-2" style="width: 33%;"
                *ngIf="permissionsMap['booking.itinerarios.reservar'] &&
                !itemChangeTwoProduct &&
                this.itinerary.items.length > 1 &&
                                  this.itinerary.status_id != 3 &&
                                  this.itinerary.status_id != 4 &&
                                  this.itinerary.status_id != 5 &&
                                  this.itinerary.status_id != 6 &&
                                  this.activeButtonPartialReserve
                ">
                    <!-- falta validar si el itinerario tiene mas de 1 producto -->


                     <button class="btn btn-block rounded btn-big"
                            (click)="activePartial(); controlShow();"
                            style="font-size: 14px;
                                  display: flex;
                                  justify-content: center;
                                  align-items: center;
                                  font-weight: 600;
                                  background-color: #bfbfbf;
                                  max-width: 100%;
                                  white-space: normal;
                                  word-break: break-word;
                                  line-height: 1;
                                  padding: 0.5rem;">
                        <p class="mb-0" style="width: 62px;text-align: start;">
                          Reserva parcial
                        </p>
                    </button>
                </div>
                <div class="mt-2"
                [ngStyle]="{
                                'width': this.itinerary.items.length > 1 &&
                                !itemChangeTwoProduct &&
                                  this.itinerary.status_id != 3 &&
                                  this.itinerary.status_id != 4 &&
                                  this.itinerary.status_id != 5 &&
                                  this.itinerary.status_id != 6 &&
                                  this.activeButtonPartialReserve  ? '65%' : '100%'}"
                *ngIf="permissionsMap['booking.itinerarios.reservar']">
                    <button *ngIf="itinerary.status_id != 3 && itinerary.status_id != 4 && itinerary.status_id != 5 && itinerary.status_id != 6"
                    class="btn btn-block rounded btn-big text-semiblack" (click)="reserve()"
                    [disabled]="((isActivePartialReserve && qtyItemsToPartial==0 || hasDisabledAlertMessage()))"
                    [ngStyle]="{'background-color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_3,
                                'color': buttonTextActive}"
                    Style="font-family: 'Poppins'; font-size: 14px; font-weight: 600;">
                        Reservar
                    </button>
                </div>
              </div>

                <div class=" row pl-2 mt-2" *ngIf="permissionsMap['booking.itinerarios.pagar']">
                    <button *ngIf="(itinerary.status_id == 2 || itinerary.status_id == 3) && searchProductReserved()"
                    class="btn btn-danger rounded btn-block btn-big " (click)="pay()"
                    Style="font-family: 'Poppins'; font-size: 14px; font-weight: 600;color: #000000"
                    [disabled]="isActivePartialReserve && qtyItemsToPartial==0">
                        Pagar
                    </button>
                </div>
                <!-- <div class="row pl-2 mt-2">
                  <button (click)="_return()" class="btn btn-block" style="height: 45px;border-radius: 50rem; cursor: pointer; background-color: #afeedd">
                    <span>REGRESAR</span>
                  </button>
                </div> -->
            </ng-container>

          </div>
    </div>
  </div>
</div>





  </div>

<ng-container  *ngIf="openModalFly && itinerary">
  <usb-flight-modal
                          class="align-items-center d-flex flex-row w-100"
                          [invoke]="1"
                          [_actualItinerary]="itinerary"
                          [getClientsSettingAppBooking]="getClientsSettingAppBooking"
                          [component]="'results'"
                          [payloadSearch]="payloadSearchTransportFly"
                          [formTransports]="formTransportsFly"
                           [openModalFly]="openModalFly"
                           (modalClosed)="onFlightModalClosed()"
                           (updateFly)="updateFly($event)"
                  >

</usb-flight-modal>
</ng-container>
